var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-chip',{staticClass:"pl-2",attrs:{"small":""}},[_c('v-avatar',{class:[_vm.colorAvatar(), 'white--text'],attrs:{"left":""}},[_c('v-icon',{attrs:{"color":"white","small":""}},[_vm._v(_vm._s(_vm.iconAvatar()))])],1),_vm._v(" "+_vm._s(_vm.prioridad)+" ")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }